export type GetQueryStringParameterProps = {
    path?: string;
    queryStringParameter: string;
};
export type GetQueryStringParameter = (
    props: GetQueryStringParameterProps
) => string;

export const getQueryStringParameter: GetQueryStringParameter = ({
    path,
    queryStringParameter
}) => {
    const queryParameterValue = path
        ?.split('&')
        .filter((value) => value.indexOf(queryStringParameter) > -1)[0]
        ?.split('=')[1];

    return queryParameterValue ? decodeURIComponent(queryParameterValue) : '';
};
